"use client";
import { useEffect } from "react";

const TAG = `HUD RLT-${Date.now()}`; // visible stamp per build

export default function GlobalDebugHUD() {
  useEffect(() => {
    // expose helpers for quick verification
    (window as any).__HUD_TAG__ = TAG;

    // add a tiny always-on overlay so we 100% know this component mounted
    const el = document.createElement("div");
    el.id = "rlt-hud-stamp";
    el.style.cssText =
      "position:fixed;bottom:6px;left:6px;z-index:2147483647;background:rgba(0,0,0,.8);color:#9effa4;padding:4px 6px;border-radius:6px;font:11px/1.2 monospace;pointer-events:none";
    el.textContent = TAG;
    document.body.appendChild(el);

    // optional: simple API for you to tweak the text
    (window as any).__hud = {
      set: (t: string) => (el.textContent = `${TAG} | ${t}`),
    };

    console.log("[GLOBAL HUD MOUNTED]", TAG);

    return () => {
      el.remove();
    };
  }, []);

  return null;
}
